import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import 'element-ui/lib/theme-chalk/index.css'

Vue.use(ElementUI,{locale});
Vue.config.productionTip = false;
// 配置请求的根路径
import api from './api/index.js'
Vue.prototype.$api = api
import helper from './utils/helper.js'
Vue.prototype.$helper = helper

//路由跳转后，页面回到顶部
router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
